export const citrinStyles = {
	header: {
		backgroundColor: '#f3f7f9',
	},
	sidebar: {
		backgroundColor: '#0C2036',
		color: 'white',
	},
	button: {
		backgroundColor: '#2DB2E0',
		color: '#FFFFFF',
		border: '1px solid #02a603',
		fontWeight: 600,
		':hover': {
			backgroundColor: '#2DB2E0',
			border: '1px solid #027d02',
		},
	},
	title: {
		color: 'black',
	},
	text: {
		color: '#292f33',
		buttonLoadingColor: '#FFFFFF',
	},
	table: {
		headerBackgroundColor: '#00467f',
		headerTextColor: '#ffffff',
	},
	platformName: {
		name: 'Citrin Parking Platform',
	},
	logo: {
		small: {
			// Will come from an s3 bucket eventually
			src: '/citrin/citrin-icon.png',
			height: 45,
			width: 45,
		},
		large: {
			src: '/citrin/citrin-logo-white-text.png',
			height: 36,
			width: 156,
		},
	},
	favicon: {
		src: '/citrin/citrin-icon.png',
	},
	socials: {},
	siteUrl: 'https://monthly.citrin.co/',
	orgName: 'Citrin',
};
